import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../auth/AuthContext";
import { useI18n } from "../i18n/LanguageContext";

export default function KycProgressCard() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    if (user?.role !== "client") return;
    api.get("/kyc/me").then((r) => setProgress(r.data.progress)).catch(() => {});
  }, [user]);

  if (user?.role !== "client" || !progress || progress.complete) return null;
  const pct = Math.round((progress.approved / progress.total) * 100);

  return (
    <div className="mt-8 br-card px-8 py-7 br-fade-up" data-testid="kyc-progress-card">
      <div className="flex flex-wrap items-center justify-between gap-6">
        <div className="min-w-0 flex-1">
          <div className="br-overline">{t("dash.kyc_overline")}</div>
          <div className="font-serif-display text-[1.6rem] text-[color:var(--br-parchment)] mt-2">
            {t("dash.kyc_title")}
          </div>
          <div className="mt-4 relative h-px w-full max-w-[420px]" style={{ background: "var(--br-line-bright)" }}>
            <div className="absolute left-0 top-0 h-px" style={{ width: `${pct}%`, background: "var(--br-bronze)" }} />
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-[0.82rem]">
            <span className="font-mono-fin" style={{ color: "var(--br-bronze)" }} data-testid="kyc-progress-count">
              {t("dash.kyc_progress", { approved: progress.approved, total: progress.total })}
            </span>
            {progress.submitted > 0 && (
              <span className="text-[color:var(--br-text-dim)]" data-testid="kyc-progress-submitted">
                {t("dash.kyc_submitted", { n: progress.submitted })}
              </span>
            )}
            {progress.rejected > 0 && (
              <span style={{ color: "#b36b6b" }} data-testid="kyc-progress-rejected">
                {t("dash.kyc_rejected", { n: progress.rejected })}
              </span>
            )}
          </div>
          <p className="mt-3 text-[0.8rem] leading-relaxed text-[color:var(--br-text-dim)] max-w-[520px]">
            {t("dash.kyc_note")}
          </p>
        </div>
        <Link to="/kyc" className="br-btn-primary flex-shrink-0" data-testid="kyc-progress-cta">
          {t("dash.kyc_cta")}
        </Link>
      </div>
    </div>
  );
}
